import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { ChangeDetectionStrategy, Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
	selector: 'app-item-select-control',
	templateUrl: './item-select-control.component.html',
	styleUrls: ['./item-select-control.component.scss'],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => ItemSelectControlComponent),
			multi: true,
		},
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class ItemSelectControlComponent implements ControlValueAccessor {
	selectedOptions = [];
	@Input() availableOptions: string[];
	@Input() availableLabelKey: string;
	@Input() selectedLabelKey: string;
	selectableOptions = [];

	dropInAll(event: CdkDragDrop<string[]>) {
		if (event.previousContainer === event.container) {
			moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
		} else {
			transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);
		}
		this.onChange(this.selectedOptions);
	}

	dropInSelected(event: CdkDragDrop<string[]>) {
		if (event.previousContainer === event.container) {
			moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
		} else {
			transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);
		}
		this.onChange(this.selectedOptions);
	}

	// ControlValueAccessor methods
	private onChange = (_: any) => {};
	private onTouched = () => {};

	writeValue(value: string[]): void {
		this.selectedOptions = value || [];
	}

	registerOnChange(fn: any): void {
		this.onChange = fn;
	}

	registerOnTouched(fn: any): void {
		this.onTouched = fn;
	}

	setDisabledState?(_: boolean): void {}
}
